import * as React from "react";
const SvgReana = (props) => /* @__PURE__ */ React.createElement("svg", { "xmlns:dc": "http://purl.org/dc/elements/1.1/", "xmlns:cc": "http://creativecommons.org/ns#", "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#", "xmlns:svg": "http://www.w3.org/2000/svg", xmlns: "http://www.w3.org/2000/svg", "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd", "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape", id: "trac\\xE9s_techniques", "data-name": "trac\\xE9s techniques", viewBox: "0 0 27.113801 6.2141157", "sodipodi:docname": "logo-reana.svg", "inkscape:version": "0.92.2 2405546, 2018-03-11", width: 150, height: 150, "inkscape:export-filename": "/Users/jbenito/Desktop/reana3.png", "inkscape:export-xdpi": 3430.814, "inkscape:export-ydpi": 3430.814, ...props }, /* @__PURE__ */ React.createElement("metadata", { id: "metadata5153" }, /* @__PURE__ */ React.createElement("rdf:RDF", null, /* @__PURE__ */ React.createElement("cc:Work", { "rdf:about": "" }, /* @__PURE__ */ React.createElement("dc:format", null, "image/svg+xml"), /* @__PURE__ */ React.createElement("dc:type", { "rdf:resource": "http://purl.org/dc/dcmitype/StillImage" }), /* @__PURE__ */ React.createElement("dc:title", null, "1")))), /* @__PURE__ */ React.createElement("sodipodi:namedview", { pagecolor: "#ffffff", bordercolor: "#666666", borderopacity: 1, objecttolerance: 10, gridtolerance: 10, guidetolerance: 10, "inkscape:pageopacity": 0, "inkscape:pageshadow": 2, "inkscape:window-width": 2560, "inkscape:window-height": 1403, id: "namedview5151", showgrid: "true", "inkscape:zoom": 49.157258, "inkscape:cx": 7.6965265, "inkscape:cy": 3.1817199, "inkscape:window-x": 1920, "inkscape:window-y": 37, "inkscape:window-maximized": 0, "inkscape:current-layer": "layer5", showguides: "true", "inkscape:guide-bbox": "true", "inkscape:measure-start": "2,4.04275", "inkscape:measure-end": "2.15268,4.04275", "fit-margin-top": 0, "fit-margin-left": 0, "fit-margin-right": 0, "fit-margin-bottom": 0 }, /* @__PURE__ */ React.createElement("inkscape:grid", { type: "xygrid", id: "grid27628", originx: -226.95152, originy: -105.95725, empspacing: 5 }), /* @__PURE__ */ React.createElement("sodipodi:guide", { position: "7.0484767,8.5163312", orientation: "1,0", id: "guide9659", "inkscape:locked": "false" })), /* @__PURE__ */ React.createElement("defs", { id: "defs5015" }, /* @__PURE__ */ React.createElement("inkscape:path-effect", { effect: "bend_path", id: "path-effect9720", is_visible: "true", bendpath: "M 0,3.1724643 H 6.0764945", prop_scale: 1, scale_y_rel: "false", vertical: "false" }), /* @__PURE__ */ React.createElement("inkscape:path-effect", { effect: "bspline", id: "path-effect4978", is_visible: "true", weight: 33.333333, steps: 2, helper_size: 0, apply_no_weight: "true", apply_with_weight: "true", only_selected: "false" }), /* @__PURE__ */ React.createElement("inkscape:path-effect", { effect: "bspline", id: "path-effect4964", is_visible: "true", weight: 33.333333, steps: 2, helper_size: 0, apply_no_weight: "true", apply_with_weight: "true", only_selected: "false" }), /* @__PURE__ */ React.createElement("style", { id: "style5013" }, ".cls-1{fill:#fff;}.cls-2,.cls-9{isolation:isolate;}.cls-3{fill:#2d3e51;}.cls-4{fill:#3d97d3;}.cls-5{fill:#ecf0f1;}.cls-6,.cls-7,.cls-8{fill:none;stroke:#2d3e51;stroke-width:1.04px;}.cls-6,.cls-8{stroke-miterlimit:10;}.cls-7,.cls-8{stroke-linecap:round;}.cls-7{stroke-linejoin:round;}.cls-9{fill:#bec3c7;opacity:0.3;}"), /* @__PURE__ */ React.createElement("clipPath", { clipPathUnits: "userSpaceOnUse", id: "clipPath27566" }, /* @__PURE__ */ React.createElement("rect", { style: {
  opacity: 1,
  fill: "#ff5555",
  fillOpacity: 0.4627451,
  stroke: "none",
  strokeWidth: 1.20000005,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "rect27568", width: 10.767135, height: 4.3520308, x: 1.9026542, y: 153.29659, transform: "rotate(-45)" })), /* @__PURE__ */ React.createElement("clipPath", { clipPathUnits: "userSpaceOnUse", id: "clipPath27602" }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  vectorEffect: "none",
  fill: "none",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.01333333,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1
}, d: "m 119.05078,106.96094 5.51172,-1.47266 -4.52344,-3.01562 -2.9375,2.98437 0.0664,2.46094 2.375,1.42969 4.39453,-1.08203 0.0391,-1.30469 z", id: "path27604", "inkscape:connector-curvature": 0, "sodipodi:nodetypes": "ccccccccc" })), /* @__PURE__ */ React.createElement("clipPath", { clipPathUnits: "userSpaceOnUse", id: "clipPath27620" }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  vectorEffect: "none",
  fill: "none",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.01333333,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1
}, d: "m 119.05078,106.96094 4.25134,-1.62202 -2.20803,-2.63751 -2.58193,0.66696 -1.42487,2.55667 0.39917,3.20847 3.87542,0.5659 1.45013,-1.3137 0.88423,-1.65224 z", id: "path27622", "inkscape:connector-curvature": 0 })), /* @__PURE__ */ React.createElement("clipPath", { clipPathUnits: "userSpaceOnUse", id: "clipPath27656" }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  vectorEffect: "none",
  fill: "none",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.01333333,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1
}, d: "m 123.93712,106.83329 h 1.9023 l -2.35014,2.44464 -4.23601,-0.58753 0.87514,-5.60008 5.3741,0.22598 -0.0288,2.95 z", id: "path27658", "inkscape:connector-curvature": 0 })), /* @__PURE__ */ React.createElement("clipPath", { clipPathUnits: "userSpaceOnUse", id: "clipPath4807" }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  vectorEffect: "none",
  fill: "none",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.01183265,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1
}, d: "m 119.05078,106.96094 4.46385,-1.76493 -1.9194,-1.88329 -2.57985,0.0884 -2.14294,2.27297 0.078,2.48623 3.48488,1.08187 3.06877,-1.50318 -0.61375,-1.44596 z", id: "path4809", "inkscape:connector-curvature": 0 })), /* @__PURE__ */ React.createElement("clipPath", { clipPathUnits: "userSpaceOnUse", id: "clipPath4823" }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  vectorEffect: "none",
  fill: "none",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.01333333,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1
}, d: "m -7.8933367,9.3143167 0.00217,5.4088663 2.0205702,-0.727129 0.076253,-5.9373626 -2.5963652,-1.1324785 z", id: "path4825", "inkscape:connector-curvature": 0 })), /* @__PURE__ */ React.createElement("clipPath", { clipPathUnits: "userSpaceOnUse", id: "clipPath4848" }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  vectorEffect: "none",
  fill: "none",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.01183265,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1
}, d: "m 119.05078,106.96094 4.46385,-1.76492 -2.3843,-2.76639 -3.07917,0.83221 -1.02986,2.69428 -0.15604,2.63187 2.37931,1.90367 2.79079,-0.35368 1.36274,-1.90368 -0.0312,-1.26912 z", id: "path4850", "inkscape:connector-curvature": 0 })), /* @__PURE__ */ React.createElement("clipPath", { clipPathUnits: "userSpaceOnUse", id: "clipPath5015" }, /* @__PURE__ */ React.createElement("g", { id: "g5021", transform: "matrix(0.88744917,0,0,0.88744917,104.97812,101.26454)" }, /* @__PURE__ */ React.createElement("path", { style: {
  color: "#000000",
  fontStyle: "normal",
  fontVariant: "normal",
  fontWeight: "normal",
  fontStretch: "normal",
  fontSize: "medium",
  lineHeight: "normal",
  fontFamily: "sans-serif",
  fontVariantLigatures: "normal",
  fontVariantPosition: "normal",
  fontVariantCaps: "normal",
  fontVariantNumeric: "normal",
  fontVariantAlternates: "normal",
  fontFeatureSettings: "normal",
  textIndent: 0,
  textAlign: "start",
  textDecoration: "none",
  textDecorationLine: "none",
  textDecorationStyle: "solid",
  textDecorationColor: "#000000",
  letterSpacing: "normal",
  wordSpacing: "normal",
  textTransform: "none",
  writingMode: "lr-tb",
  direction: "ltr",
  textOrientation: "mixed",
  dominantBaseline: "auto",
  baselineShift: "baseline",
  textAnchor: "start",
  whiteSpace: "normal",
  shapePadding: 0,
  clipRule: "nonzero",
  display: "inline",
  overflow: "visible",
  visibility: "visible",
  opacity: 1,
  isolation: "auto",
  mixBlendMode: "normal",
  colorInterpolation: "sRGB",
  colorInterpolationFilters: "linearRGB",
  solidColor: "#000000",
  solidOpacity: 1,
  vectorEffect: "none",
  fill: "#b13e51",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 1.31162977,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1,
  colorRendering: "auto",
  imageRendering: "auto",
  shapeRendering: "auto",
  textRendering: "auto",
  enableBackground: "accumulate"
}, d: "m 13.265001,0.03937826 c -1.669346,0 -3.037143,1.36706424 -3.037143,3.03714294 0,1.67009 1.367797,3.0393516 3.037143,3.0393516 1.669335,0 3.034934,-1.3692616 3.034946,-3.0393516 -1.2e-5,-1.6700787 -1.365611,-3.03714294 -3.034946,-3.03714294 z m 0,1.31169204 c 0.959604,1.13e-5 1.723242,0.7633451 1.723242,1.7254509 0,0.9621171 -0.763638,1.7276595 -1.723242,1.7276595 -0.959616,0 -1.725451,-0.7655424 -1.725451,-1.7276595 0,-0.9621058 0.765835,-1.7254396 1.725451,-1.7254509 z", clipPath: "none", id: "path5017", "inkscape:connector-curvature": 0 }), /* @__PURE__ */ React.createElement("rect", { y: 2.0464592, x: 15.277344, height: 1.1875, width: 2.4375, id: "rect5019", style: {
  opacity: 1,
  fill: "#b13e51",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0.528,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
} }))), /* @__PURE__ */ React.createElement("clipPath", { clipPathUnits: "userSpaceOnUse", id: "clipPath13500" }, /* @__PURE__ */ React.createElement("g", { id: "g13510", transform: "rotate(-40,2.9975198,3.0428183)" }, /* @__PURE__ */ React.createElement("circle", { transform: "rotate(40)", cy: 1.7051548, cx: 2.2148232, id: "circle13502", style: {
  opacity: 1,
  fill: "#2d3e51",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0.34439772,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, r: 0.65226823, d: "m 2.8670915,1.7051548 c 0,0.3602378 -0.2920305,0.6522682 -0.6522683,0.6522682 -0.3602378,0 -0.6522682,-0.2920304 -0.6522682,-0.6522682 0,-0.3602378 0.2920304,-0.6522683 0.6522682,-0.6522683 0.3602378,0 0.6522683,0.2920305 0.6522683,0.6522683 z" }), /* @__PURE__ */ React.createElement("rect", { transform: "rotate(6)", y: 2.7011158, x: -0.54495627, height: 1.6807438, width: 4, id: "rect13504", style: {
  opacity: 1,
  fill: "#2d3e51",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0.528,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, d: "M -0.54495627,2.7011158 H 3.4550437 v 1.6807439 h -3.99999997 z" }), /* @__PURE__ */ React.createElement("rect", { y: 3.0622048, x: -1.1746705, height: 3.494827, width: 7.6535983, id: "rect13506", style: {
  opacity: 1,
  fill: "#2d3e51",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0.528,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, d: "m -1.1746705,3.0622048 7.6535984,0 v 3.4948271 l -7.6535984,0 z" }), /* @__PURE__ */ React.createElement("rect", { y: -0.18455514, x: 3.7283018, height: 4.5162797, width: 2.5390391, id: "rect13508", style: {
  opacity: 1,
  fill: "#2d3e51",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0.528,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, d: "M 3.7283018,-0.18455514 H 6.2673409 V 4.3317246 H 3.7283018 Z" })))), /* @__PURE__ */ React.createElement("title", { id: "title5017" }, "1"), /* @__PURE__ */ React.createElement("g", { "inkscape:groupmode": "layer", id: "layer1", "inkscape:label": "e-a-cont", style: {
  display: "none"
}, transform: "translate(-6.9515233)" }, /* @__PURE__ */ React.createElement("path", { style: {
  color: "#000000",
  fontStyle: "normal",
  fontVariant: "normal",
  fontWeight: "normal",
  fontStretch: "normal",
  fontSize: "medium",
  lineHeight: "normal",
  fontFamily: "sans-serif",
  fontVariantLigatures: "normal",
  fontVariantPosition: "normal",
  fontVariantCaps: "normal",
  fontVariantNumeric: "normal",
  fontVariantAlternates: "normal",
  fontFeatureSettings: "normal",
  textIndent: 0,
  textAlign: "start",
  textDecoration: "none",
  textDecorationLine: "none",
  textDecorationStyle: "solid",
  textDecorationColor: "#000000",
  letterSpacing: "normal",
  wordSpacing: "normal",
  textTransform: "none",
  writingMode: "lr-tb",
  direction: "ltr",
  textOrientation: "mixed",
  dominantBaseline: "auto",
  baselineShift: "baseline",
  textAnchor: "start",
  whiteSpace: "normal",
  shapePadding: 0,
  clipRule: "nonzero",
  display: "inline",
  overflow: "visible",
  visibility: "visible",
  opacity: 1,
  isolation: "auto",
  mixBlendMode: "normal",
  colorInterpolation: "sRGB",
  colorInterpolationFilters: "linearRGB",
  solidColor: "#000000",
  solidOpacity: 1,
  vectorEffect: "none",
  fill: "#ff3336",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 1.1640048,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1,
  colorRendering: "auto",
  imageRendering: "auto",
  shapeRendering: "auto",
  textRendering: "auto",
  enableBackground: "accumulate"
}, d: "m 120.36719,103.48242 c -1.48146,0 -2.69531,1.2132 -2.69531,2.69531 0,1.48212 1.21385,2.69727 2.69531,2.69727 1.48145,0 2.69335,-1.21515 2.69336,-2.69727 -1e-5,-1.48211 -1.21191,-2.69531 -2.69336,-2.69531 z m 0,1.16406 c 0.8516,1e-5 1.52929,0.67743 1.52929,1.53125 0,0.85383 -0.67769,1.53321 -1.52929,1.53321 -0.85161,0 -1.53125,-0.67938 -1.53125,-1.53321 0,-0.85382 0.67964,-1.53124 1.53125,-1.53125 z", clipPath: "url(#clipPath5015)", id: "ellipse4852", "inkscape:connector-curvature": 0, transform: "matrix(1.1268251,0,0,1.1268251,-118.29198,-114.03742)" })), /* @__PURE__ */ React.createElement("g", { "inkscape:groupmode": "layer", id: "layer5", "inkscape:label": "ico-flow", style: {
  display: "inline"
}, transform: "translate(-6.9515233)" }), /* @__PURE__ */ React.createElement("g", { "inkscape:groupmode": "layer", id: "layer6", "inkscape:label": "ico-main-triag", style: {
  display: "none"
}, transform: "translate(-6.9515233)" }), /* @__PURE__ */ React.createElement("g", { "inkscape:groupmode": "layer", id: "layer7", "inkscape:label": "ico-recycle", style: {
  display: "none"
}, transform: "translate(-6.9515233)" }, /* @__PURE__ */ React.createElement("path", { "inkscape:connector-curvature": 0, id: "path9653", clipPath: "url(#clipPath13500)", d: "m -0.1,3.1713656 c 0,1.6693463 1.3670642,3.037143 3.037143,3.037143 1.67009,0 3.0393515,-1.3677967 3.0393515,-3.037143 0,-1.669335 -1.3692615,-3.03493435 -3.0393515,-3.03494562 C 1.2670642,0.13643125 -0.1,1.5020306 -0.1,3.1713656 Z m 1.311692,0 c 1.13e-5,-0.9596042 0.7633452,-1.7232423 1.725451,-1.7232423 0.962117,0 1.7276595,0.7636381 1.7276595,1.7232423 0,0.9596155 -0.7655425,1.725451 -1.7276595,1.725451 -0.9621058,0 -1.7254397,-0.7658355 -1.725451,-1.725451 z", style: {
  color: "#000000",
  fontStyle: "normal",
  fontVariant: "normal",
  fontWeight: "normal",
  fontStretch: "normal",
  fontSize: "medium",
  lineHeight: "normal",
  fontFamily: "sans-serif",
  fontVariantLigatures: "normal",
  fontVariantPosition: "normal",
  fontVariantCaps: "normal",
  fontVariantNumeric: "normal",
  fontVariantAlternates: "normal",
  fontFeatureSettings: "normal",
  textIndent: 0,
  textAlign: "start",
  textDecoration: "none",
  textDecorationLine: "none",
  textDecorationStyle: "solid",
  textDecorationColor: "#000000",
  letterSpacing: "normal",
  wordSpacing: "normal",
  textTransform: "none",
  writingMode: "lr-tb",
  direction: "ltr",
  textOrientation: "mixed",
  dominantBaseline: "auto",
  baselineShift: "baseline",
  textAnchor: "start",
  whiteSpace: "normal",
  shapePadding: 0,
  clipRule: "nonzero",
  display: "inline",
  overflow: "visible",
  visibility: "visible",
  opacity: 1,
  isolation: "auto",
  mixBlendMode: "normal",
  colorInterpolation: "sRGB",
  colorInterpolationFilters: "linearRGB",
  solidColor: "#000000",
  solidOpacity: 1,
  vectorEffect: "none",
  fill: "#2d3e51",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 1.31162977,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1,
  colorRendering: "auto",
  imageRendering: "auto",
  shapeRendering: "auto",
  textRendering: "auto",
  enableBackground: "accumulate"
}, "inkscape:path-effect": "#path-effect9720", "inkscape:original-d": "m 0,3.1713656 c 0,1.6693463 1.3670642,3.037143 3.037143,3.037143 1.67009,0 3.0393515,-1.3677967 3.0393515,-3.037143 0,-1.669335 -1.3692615,-3.03493436 -3.0393515,-3.03494563 C 1.3670642,0.13643124 0,1.5020306 0,3.1713656 Z m 1.311692,0 c 1.13e-5,-0.9596042 0.7633452,-1.7232423 1.725451,-1.7232423 0.962117,0 1.7276595,0.7636381 1.7276595,1.7232423 0,0.9596155 -0.7655425,1.725451 -1.7276595,1.725451 -0.9621058,0 -1.7254397,-0.7658355 -1.725451,-1.725451 z", transform: "rotate(50,3.2121245,3.5509762)", "inkscape:export-filename": "/Users/jbenito/Desktop/reana3.png", "inkscape:export-xdpi": 3430.814, "inkscape:export-ydpi": 3430.814 }), /* @__PURE__ */ React.createElement("path", { "sodipodi:type": "star", style: {
  opacity: 1,
  fill: "#2d3e51",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0.528,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path9657-7", "sodipodi:sides": 3, "sodipodi:cx": -3, "sodipodi:cy": -0.75139636, "sodipodi:r1": 1.4199692, "sodipodi:r2": 0.7099846, "sodipodi:arg1": 1.5707963, "sodipodi:arg2": 2.6179939, "inkscape:flatsided": "false", "inkscape:rounded": 0, "inkscape:randomized": 0, d: "M -3,0.66857284 -3.6148647,-0.39640407 -4.2297294,-1.4613809 -3,-1.461381 l 1.2297294,0 -0.6148647,1.06497696 z", transform: "rotate(140,0.51756791,1.6470036)", "inkscape:transform-center-x": -0.24282906, "inkscape:transform-center-y": 0.12328755, "inkscape:export-filename": "/Users/jbenito/Desktop/reana3.png", "inkscape:export-xdpi": 3430.814, "inkscape:export-ydpi": 3430.814 }), /* @__PURE__ */ React.createElement("circle", { style: {
  opacity: 1,
  fill: "#ff3336",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0.45651662,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path13512", cx: 3.319088, cy: 3.1800606, r: 0.86461473, "inkscape:export-filename": "/Users/jbenito/Desktop/reana3.png", "inkscape:export-xdpi": 3430.814, "inkscape:export-ydpi": 3430.814 }), /* @__PURE__ */ React.createElement("path", { style: {
  display: "inline",
  opacity: 1,
  fill: "#ff3336",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0.43005931,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path13512-0", cx: 3.2287376, cy: 2.8911374, r: 0.81450623, d: "", "inkscape:connector-curvature": 0 })), /* @__PURE__ */ React.createElement("g", { style: {
  display: "none"
}, "inkscape:label": "ico-y-y", id: "g13609", "inkscape:groupmode": "layer", transform: "translate(-6.9515233)" }, /* @__PURE__ */ React.createElement("path", { transform: "rotate(50,3.5378454,3.4522015)", "inkscape:original-d": "m 0,3.1713656 c 0,1.6693463 1.3670642,3.037143 3.037143,3.037143 1.67009,0 3.0393515,-1.3677967 3.0393515,-3.037143 0,-1.669335 -1.3692615,-3.03493436 -3.0393515,-3.03494563 C 1.3670642,0.13643124 0,1.5020306 0,3.1713656 Z m 1.311692,0 c 1.13e-5,-0.9596042 0.7633452,-1.7232423 1.725451,-1.7232423 0.962117,0 1.7276595,0.7636381 1.7276595,1.7232423 0,0.9596155 -0.7655425,1.725451 -1.7276595,1.725451 -0.9621058,0 -1.7254397,-0.7658355 -1.725451,-1.725451 z", "inkscape:path-effect": "#path-effect9720", style: {
  color: "#000000",
  fontStyle: "normal",
  fontVariant: "normal",
  fontWeight: "normal",
  fontStretch: "normal",
  fontSize: "medium",
  lineHeight: "normal",
  fontFamily: "sans-serif",
  fontVariantLigatures: "normal",
  fontVariantPosition: "normal",
  fontVariantCaps: "normal",
  fontVariantNumeric: "normal",
  fontVariantAlternates: "normal",
  fontFeatureSettings: "normal",
  textIndent: 0,
  textAlign: "start",
  textDecoration: "none",
  textDecorationLine: "none",
  textDecorationStyle: "solid",
  textDecorationColor: "#000000",
  letterSpacing: "normal",
  wordSpacing: "normal",
  textTransform: "none",
  writingMode: "lr-tb",
  direction: "ltr",
  textOrientation: "mixed",
  dominantBaseline: "auto",
  baselineShift: "baseline",
  textAnchor: "start",
  whiteSpace: "normal",
  shapePadding: 0,
  clipRule: "nonzero",
  display: "inline",
  overflow: "visible",
  visibility: "visible",
  opacity: 1,
  isolation: "auto",
  mixBlendMode: "normal",
  colorInterpolation: "sRGB",
  colorInterpolationFilters: "linearRGB",
  solidColor: "#000000",
  solidOpacity: 1,
  vectorEffect: "none",
  fill: "#2d3e51",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 1.31162977,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1,
  colorRendering: "auto",
  imageRendering: "auto",
  shapeRendering: "auto",
  textRendering: "auto",
  enableBackground: "accumulate"
}, d: "m -0.1,3.1713656 c 0,1.6693463 1.3670642,3.037143 3.037143,3.037143 1.67009,0 3.0393515,-1.3677967 3.0393515,-3.037143 0,-1.669335 -1.3692615,-3.03493435 -3.0393515,-3.03494562 C 1.2670642,0.13643125 -0.1,1.5020306 -0.1,3.1713656 Z m 1.311692,0 c 1.13e-5,-0.9596042 0.7633452,-1.7232423 1.725451,-1.7232423 0.962117,0 1.7276595,0.7636381 1.7276595,1.7232423 0,0.9596155 -0.7655425,1.725451 -1.7276595,1.725451 -0.9621058,0 -1.7254397,-0.7658355 -1.725451,-1.725451 z", clipPath: "url(#clipPath13500)", id: "path13601", "inkscape:connector-curvature": 0 }), /* @__PURE__ */ React.createElement("path", { "inkscape:transform-center-y": 0.12328755, "inkscape:transform-center-x": -0.24282906, transform: "rotate(140,0.5897402,1.5120077)", d: "M -3,0.66857284 -3.6148647,-0.39640407 -4.2297294,-1.4613809 -3,-1.461381 l 1.2297294,0 -0.6148647,1.06497696 z", "inkscape:randomized": 0, "inkscape:rounded": 0, "inkscape:flatsided": "false", "sodipodi:arg2": 2.6179939, "sodipodi:arg1": 1.5707963, "sodipodi:r2": 0.7099846, "sodipodi:r1": 1.4199692, "sodipodi:cy": -0.75139636, "sodipodi:cx": -3, "sodipodi:sides": 3, id: "path13603", style: {
  opacity: 1,
  fill: "#2d3e51",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0.528,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, "sodipodi:type": "star" }), /* @__PURE__ */ React.createElement("circle", { r: 0.81450623, cy: 3.1597178, cx: 3.319088, id: "circle13605", style: {
  opacity: 1,
  fill: "#ff3336",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0.43005931,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { "inkscape:connector-curvature": 0, d: "", r: 0.81450623, cy: 2.8911374, cx: 3.2287376, id: "path13607", style: {
  display: "inline",
  opacity: 1,
  fill: "#ff3336",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0.43005931,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
} })), /* @__PURE__ */ React.createElement("g", { "inkscape:groupmode": "layer", id: "layer2", "inkscape:label": "main", transform: "translate(-6.9515233)" }, /* @__PURE__ */ React.createElement("path", { id: "path9431", className: "cls-3", d: "m 34.065325,2.2647192 v 3.8490552 h -1.85201 V 5.4332171 A 2.1309265,2.1309265 0 0 1 30.405933,6.203028 1.8296959,1.8296959 0 0 1 28.375418,4.351019 c 0,-1.1156683 0.803281,-1.7739127 2.231335,-1.7850694 h 1.55078 v -0.089253 c 0,-0.5801478 -0.379328,-0.9260048 -1.115668,-0.9260048 A 4.2283831,4.2283831 0 0 0 29.279108,2.0415851 L 28.743588,0.79203641 A 6.2477428,6.2477428 0 0 1 31.476975,0.1226354 c 1.628875,0 2.566036,0.80328122 2.577194,2.1420835 z M 32.202159,4.1167286 V 3.5812077 h -1.193764 c -0.568992,0 -0.847907,0.2008204 -0.847907,0.635931 0,0.4351103 0.30123,0.7028707 0.825592,0.7028707 a 1.1937652,1.1937652 0 0 0 1.216079,-0.8032808 z", "inkscape:connector-curvature": 0, style: {
  fill: "#2d3e51",
  strokeWidth: 1.1156683
} }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "#2d3e51",
  strokeWidth: 1.13809323
}, "inkscape:connector-curvature": 0, d: "M 28.093562,2.3120693 V 6.1133005 H 26.181568 V 2.8469728 A 1.0356649,1.0356649 0 0 0 25.111757,1.7088797 1.2405218,1.2405218 0 0 0 23.882616,2.9266394 V 6.1133005 H 21.94786 V 0.09278707 h 1.934756 V 1.0715473 a 2.2761865,2.2761865 0 0 1 2.014428,-1.06980771 2.1168534,2.1168534 0 0 1 2.196518,2.27618661 z", className: "cls-3", id: "path9897" }), /* @__PURE__ */ React.createElement("rect", { style: {
  opacity: 1,
  fill: "#ff3336",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 2.25067377,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "rect22907", width: 1.6334349, height: 5.9998546, x: 6.9515233, y: 0.16101785 }), /* @__PURE__ */ React.createElement("ellipse", { style: {
  opacity: 1,
  fill: "none",
  fillOpacity: 1,
  stroke: "#ff3336",
  strokeWidth: 1.1640048,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path27554", cx: 117.7763, cy: 106.19373, rx: 2.1121941, ry: 2.114804, clipPath: "url(#clipPath27566)", transform: "matrix(1.2363656,0,0,1.1156684,-135.29642,-115.35379)" }), /* @__PURE__ */ React.createElement("path", { style: {
  color: "#000000",
  fontStyle: "normal",
  fontVariant: "normal",
  fontWeight: "normal",
  fontStretch: "normal",
  fontSize: "medium",
  lineHeight: "normal",
  fontFamily: "sans-serif",
  fontVariantLigatures: "normal",
  fontVariantPosition: "normal",
  fontVariantCaps: "normal",
  fontVariantNumeric: "normal",
  fontVariantAlternates: "normal",
  fontFeatureSettings: "normal",
  textIndent: 0,
  textAlign: "start",
  textDecoration: "none",
  textDecorationLine: "none",
  textDecorationStyle: "solid",
  textDecorationColor: "#000000",
  letterSpacing: "normal",
  wordSpacing: "normal",
  textTransform: "none",
  writingMode: "lr-tb",
  direction: "ltr",
  textOrientation: "mixed",
  dominantBaseline: "auto",
  baselineShift: "baseline",
  textAnchor: "start",
  whiteSpace: "normal",
  shapePadding: 0,
  clipRule: "nonzero",
  display: "inline",
  overflow: "visible",
  visibility: "visible",
  opacity: 1,
  isolation: "auto",
  mixBlendMode: "normal",
  colorInterpolation: "sRGB",
  colorInterpolationFilters: "linearRGB",
  solidColor: "#000000",
  solidOpacity: 1,
  vectorEffect: "none",
  fill: "#ff3336",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 1.1640048,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1,
  colorRendering: "auto",
  imageRendering: "auto",
  shapeRendering: "auto",
  textRendering: "auto",
  enableBackground: "accumulate"
}, d: "m 120.36719,103.48242 c -1.48146,0 -2.69531,1.2132 -2.69531,2.69531 0,1.48212 1.21385,2.69727 2.69531,2.69727 1.48145,0 2.69335,-1.21515 2.69336,-2.69727 -1e-5,-1.48211 -1.21191,-2.69531 -2.69336,-2.69531 z m 0,1.16406 c 0.8516,1e-5 1.52929,0.67743 1.52929,1.53125 0,0.85383 -0.67769,1.53321 -1.52929,1.53321 -0.85161,0 -1.53125,-0.67938 -1.53125,-1.53321 0,-0.85382 0.67964,-1.53124 1.53125,-1.53125 z", clipPath: "url(#clipPath4848)", id: "ellipse27558", "inkscape:connector-curvature": 0, transform: "matrix(1.1268251,0,0,1.1268251,-122.36777,-116.49721)" }), /* @__PURE__ */ React.createElement("rect", { y: 8.7706623, x: -7.9148216, height: 4.6054883, width: 1.2538248, id: "rect27570", style: {
  opacity: 1,
  fill: "#ff3336",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 1.72761714,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "rotate(-111.55,0.14653748,-0.02013487)", clipPath: "url(#clipPath4823)" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "#2d3e51",
  strokeWidth: 1.1156683
}, "inkscape:connector-curvature": 0, d: "M 21.59783,2.2634358 V 6.1124911 H 19.745822 V 5.4319333 a 2.1309265,2.1309265 0 0 1 -1.807384,0.7698113 1.8296959,1.8296959 0 0 1 -2.030516,-1.852009 c 0,-1.1156684 0.803283,-1.7739126 2.231337,-1.7850694 h 1.550778 v -0.089253 c 0,-0.5801476 -0.379325,-0.9260048 -1.115667,-0.9260048 A 4.2283831,4.2283831 0 0 0 16.811613,2.0403021 L 16.276092,0.79075338 a 6.2477428,6.2477428 0 0 1 2.733389,-0.669401 c 1.628875,0 2.566036,0.80328122 2.577193,2.14208342 z M 19.734664,4.1154452 V 3.5799246 H 18.5409 c -0.568992,0 -0.847908,0.20082 -0.847908,0.6359306 0,0.4351104 0.301231,0.7028707 0.825595,0.7028707 a 1.1937652,1.1937652 0 0 0 1.216077,-0.8032807 z", className: "cls-3", id: "path9863" })));
export default SvgReana;
